import {
  AutomatedTask,
  Conditions,
  CouponCashback,
  CouponDiscount,
  Emails,
  Funnel,
  Kanban,
  Notes,
  PartnerPerformance,
  Phases,
  Tasks,
  UserMetrics
} from './illustrations'

const Illustrations = {
  'automated-task': AutomatedTask,
  conditions: Conditions,
  'coupon-cashback': CouponCashback,
  'coupon-discount': CouponDiscount,
  emails: Emails,
  funnel: Funnel,
  kanban: Kanban,
  notes: Notes,
  'partner-performance': PartnerPerformance,
  phases: Phases,
  tasks: Tasks,
  'user-metrics': UserMetrics
} as const

type IllustrationName = keyof typeof Illustrations

interface IllustrationProps {
  name: IllustrationName
  size?: number
  className?: string
  alt?: string
}

export const Illustration = ({
  name,
  size = 100,
  className,
  alt = ''
}: IllustrationProps) => {
  const Svg = Illustrations[name]

  if (!Svg) return null

  const a11y = alt
    ? { role: 'img', 'aria-label': alt }
    : { 'aria-hidden': true }

  return <Svg className={className} height={size} width={size} {...a11y} />
}

Illustration.displayName = 'Illustration'
